// @ts-nocheck
import React, { useEffect } from 'react';

export const YandexTGOBlock = () => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (!window.yaContextCb) window.yaContextCb = [];

      window.yaContextCb.push(() => {
        window.Ya?.Context?.AdvManager?.render({
          blockId: 'R-A-16691543-1',
          renderTo: 'yandex_rtb_R-A-16691543-1',
        });
      });
    }
  }, []);

  return (
    <div
      id="yandex_rtb_R-A-16691543-1"
      style={{
        maxHeight: '230px',
        width: '100%',
        borderRadius: '10px',
        overflow: 'hidden',
      }}
    />
  );
};
